import { Component } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-cfi-master',
  standalone:false,
  templateUrl: './cfi-master.component.html',
})
export class CfiMasterComponent {
  title = 'CFI Master';
  showDeleteDialog: boolean = false;
  cfiRows: any[] = [];
  selectedCfiRows: any[] = [];
  createForm = new FormGroup({
    indent_no: new FormControl(''),
    remark: new FormControl(''),
   
  });

  constructor(private api: ApiService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.getCfiRows();
  }

  editCfi(event: any): void {
    this.currentCfiRowData = event;
    this.showDialog = true;
    this.createForm.patchValue({
      indent_no: this.currentCfiRowData.indent_no,
      remark: this.currentCfiRowData.remark,
    });
    this.file = null;
  }

  getCfiRows(): void {
    this.api.getAPI('/master/cfi-master/').subscribe((res: any) => {
      this.cfiRows = res.data;
    });
  }
  additionalButtons: any[] = [
    {
      label: 'change Status',
      icon: 'pi pi-check-circle',
      action: 'changeStatus'
    }
  ];

  currentCfiRowData: any = null;
  showDeletePopup(event: any): void {
    this.showDeleteDialog = true;
    this.currentCfiRowData = event;
  }
  deleteCfi(): void {
    this.api.postAPI(`/master/cfi-master/`,{id: this.currentCfiRowData.id,action: 'delete'}).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'CFI deleted successfully'
      });
      this.getCfiRows();
    });
  }

  file: any;
  showDialog: boolean = false;
  submitForm() {
    if(!this.file && !this.currentCfiRowData?.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please upload a file'
      });
      return;
    }
    const fd = new FormData();
    fd.append('indent_no', this.createForm.value.indent_no);
    fd.append('remark', this.createForm.value.remark);
    this.currentCfiRowData?.id ? fd.append('action', 'update') : fd.append('action', 'create');
    this.currentCfiRowData?.id ? fd.append('id', this.currentCfiRowData.id) : '';
    this.file ? fd.append('item_file', this.file) :'';
    this.api.postAPI('/master/cfi-master/', fd).subscribe((res: any) => {
      this.currentCfiRowData=null
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'CFI submitted successfully'
      });
      this.showDialog = false;
      this.createForm.reset();
      this.getCfiRows();

    });

  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    console.log(this.file);
  }

  downloadCSV(): void {
    const headers = ['Part No/Pattern No', 'Ser', 'Indenter Reference no & date', 'Project/class of ship','Main equipment', 'Equipment code', 'Equipment category (E/L/W/H)', 'Item description', 'Quantity', 'Brief Specs', 'Substitute available if any', 'Unit Cost', 'Currency', 'Total cost', 'Last source of supply & year','LPP', 'Frequency of Requirement', 'Availability of stock sample'];
    const csv = headers.join(',') + '\r\n';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'item-cfi.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  cfiListColumns: any[] = [
    { field: 'ser', header: 'Ser' },
    { field: 'part_no', header: 'Part No/Pattern No' },
    { field: 'item_status', header: 'Status' },
    { field: 'indenter_referance', header: 'Indenter Reference no & date' },
    { field: 'project_class', header: 'Project/class of ship' },
    { field: 'main_equipment', header: 'Main equipment' },
    { field: 'equipment_code', header: 'Equipment code' },
    { field: 'equipment_category', header: 'Equipment category' },
    { field: 'item_desc', header: 'Item description' },
    { field: 'qty', header: 'Quantity' },
    { field: 'brief_specs', header: 'Brief specs' },
    { field: 'substitute', header: 'Substitute available if any' },
    { field: 'total_cost', header: 'Total cost' },
    { field: 'last_source_of_supply', header: 'Last source of supply & year' },
    { field: 'lpp', header: 'LPP' },
    { field: 'frequency_requirement', header: 'Frequency of requirement' },
    { field: 'availability_stock', header: 'Availability of stock sample' },

  ];


  onSelectionChange(event: any) {
    this.selectedCfiRows = event;
    console.log(this.selectedCfiRows);
  }
  
    // Add these to the CfiTransactionComponent class:
    showIndigenisationPopup: boolean = false;
    indigenisationOptions = [
      { label: 'Indigenised', value: 'indigenised' },
      { label: 'Not Indigenised', value: 'not_indigenised' },
      { label: 'Working Indigenisation', value: 'working' },
    ];
    selectedIndigenisation: any = null;
    workingCompletionDate: Date | null = null;
  
    onIndigenisationSubmit() {
      const payload = {
        id: this.selectedCfiRows.map((row: any) => row.id),
        item_status: this.selectedIndigenisation?.value,
        action: 'update',
      }
      if(this.selectedIndigenisation?.value === 'working') {
        payload['working_completion_date'] = this.workingCompletionDate.toISOString().split('T')[0] ;
      }
      this.api.postAPI('/master/cfi-master/', payload).subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'CFI status changed successfully'
        });
        this.getCfiRows();
      });
      this.showIndigenisationPopup = false;
    }
}
